export enum DesignSystemColors {
  PINK_008 = '#FBE9EF',
  PINK_014 = '#F8DBE5',
  PINK_027 = '#F3C3D3',
  PINK_051 = '#ECA0BA',
  PINK_088 = '#E47A9E',
  PINK_142 = '#DC4E7E',
  PINK_201 = '#D3235F',
  PINK_306 = '#A91B4B',
  PINK_470 = '#7D1437',
  PINK_650 = '#570E27',
  PINK_794 = '#3B0A1A',
  RED_008 = '#FEEAEA',
  RED_014 = '#FDDCDC',
  RED_027 = '#FBC2C2',
  RED_051 = '#F89D9D',
  RED_088 = '#F57373',
  RED_142 = '#F13C3C',
  RED_201 = '#E00000',
  RED_306 = '#B40000',
  RED_470 = '#870000',
  RED_650 = '#600000',
  RED_794 = '#430000',
  ORANGE_008 = '#FEEBD7',
  ORANGE_014 = '#FDDEBE',
  ORANGE_027 = '#FBC68F',
  ORANGE_088 = '#F8A34C',
  ORANGE_051 = '#EB7F10',
  ORANGE_142 = '#C56A0E',
  ORANGE_201 = '#A85B0C',
  ORANGE_306 = '#864809',
  ORANGE_470 = '#613507',
  ORANGE_650 = '#432405',
  ORANGE_794 = '#2D1803',
  YELLOW_008 = '#FCF09A',
  YELLOW_014 = '#FAE44B',
  YELLOW_027 = '#EDCF04',
  YELLOW_051 = '#CFB603',
  YELLOW_088 = '#B29B03',
  YELLOW_142 = '#948202',
  YELLOW_201 = '#7F6F02',
  YELLOW_306 = '#645802',
  YELLOW_470 = '#494001',
  YELLOW_650 = '#322C01',
  YELLOW_794 = '#221D01',
  GREEN_008 = '#E2F3CF',
  GREEN_014 = '#D1EBB2',
  GREEN_027 = '#B2DE7E',
  GREEN_051 = '#82C92D',
  GREEN_088 = '#5FAF00',
  GREEN_142 = '#4F9200',
  GREEN_201 = '#447C00',
  GREEN_306 = '#366300',
  GREEN_470 = '#284800',
  GREEN_650 = '#1B3100',
  GREEN_794 = '#122100',
  TEAL_008 = '#D5F3EE',
  TEAL_014 = '#BEECE4',
  TEAL_027 = '#8EDED0',
  TEAL_051 = '#48C9B3',
  TEAL_088 = '#1BAF95',
  TEAL_142 = '#16927C',
  TEAL_201 = '#137D6A',
  TEAL_306 = '#0F6455',
  TEAL_470 = '#0B483E',
  TEAL_650 = '#08312A',
  TEAL_794 = '#05211D',
  BLUE_008 = '#E8EEFE',
  BLUE_014 = '#D9E2FD',
  BLUE_027 = '#C2CFFC',
  BLUE_051 = '#9DB3FB',
  BLUE_088 = '#7997F9',
  BLUE_142 = '#5279F7',
  BLUE_201 = '#3360F6',
  BLUE_306 = '#1F49D2',
  BLUE_470 = '#17359A',
  BLUE_650 = '#10256B',
  BLUE_794 = '#0B1947',
  PURPLE_008 = '#F2EAFD',
  PURPLE_014 = '#EADEFB',
  PURPLE_027 = '#DCC8F8',
  PURPLE_051 = '#C8A7F4',
  PURPLE_088 = '#B386F1',
  PURPLE_142 = '#9D63EC',
  PURPLE_201 = '#8B47E9',
  PURPLE_306 = '#6F38B9',
  PURPLE_470 = '#512987',
  PURPLE_650 = '#381C5D',
  PURPLE_794 = '#25133F'
}
